import { Grid as GridMUI } from "@mui/material";
import { styled } from "@mui/material/styles";

import GenericModal from "../../../Modal";

export const CommentsContainer = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  height: "100%",
  minHeight: "2em",
  width: "100%",
}));

export const Modal = styled(GenericModal)(() => ({
  "& #modalHeader": {
    padding: "24px 24px 0 24px !important",
    "& .MuiIconButton-root": {
      right: "-12px !important",
    },
  },
  "& #modalBody": {
    flexDirection: "column",
    flexWrap: "nowrap",
    height: "100%",
    margin: "unset !important",
    overflow: "hidden",
    padding: "0 !important",
  },
}));

export const ModalGrid = styled(GridMUI)(() => ({
  flexShrink: 0,
  margin: 0,
  padding: "32px 24px",
}));
